import axios from 'axios';

export const API_BASE_URL = 'https://backend.carswipe.in/api';
// For local testing (backend on your machine):
// export const API_BASE_URL = 'http://localhost:2000/api';

// Client for cookie-authenticated endpoints (auth, analytics, invoices).
// withCredentials sends the httpOnly auth cookie; the token is never readable from JS.
export const authApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});
